import { apiService } from '.';
import { ParamFunctionariesSwitchboard } from '../shared/types/param';
import {
    FunctionariesSwitch,
    FunctionariesSwitchHistorical,
} from '../shared/types/systemConfiguration/functionariesSwitch';

export const asyncGetFunctionariesSwitchFilters = async (
    filters?: ParamFunctionariesSwitchboard,
    page?: number,
    pageSize?: number
): Promise<{ items: FunctionariesSwitch[]; length: number }> => {
    try {
        const {
            items: data,
        }: { items: { items: FunctionariesSwitch[]; length: number } } =
            await apiService.get(`/api/functionaries-switch/filters`, {
                limit: pageSize || 0,
                page: page || 0,
                ...filters,
            });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetFunctionariesSwitchSelect = async (
    filters?: ParamFunctionariesSwitchboard,
    page?: number,
    pageSize?: number
): Promise<{ items: FunctionariesSwitch[]; length: number }> => {
    try {
        const {
            items: data,
        }: { items: { items: FunctionariesSwitch[]; length: number } } =
            await apiService.get(`/api/functionaries-switch/functionaries`, {
                limit: pageSize || 0,
                page: page || 0,
                ...filters,
            });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncUpdateFunctionariesSwitch = async (
    id: string,
    functionariesSwitch: FunctionariesSwitch
): Promise<FunctionariesSwitch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FunctionariesSwitch;
        } = await apiService.patch(
            `/api/functionaries-switch/${id}`,
            functionariesSwitch
        );
        return data;
    } catch (error) {
        console.error('Error al actualizar el funcionario:', error);
    }
};

export const asyncCreateFunctionariesSwitch = async (
    functionariesSwitch: FunctionariesSwitch
): Promise<FunctionariesSwitch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FunctionariesSwitch;
        } = await apiService.post(
            `/api/functionaries-switch`,
            functionariesSwitch
        );
        return data;
    } catch (error) {
        console.error('Error al crear el funcionario:', error);
    }
};

export const asyncGetFunctionariesSwitch = async (
    idFunctionarySwitch: any
): Promise<FunctionariesSwitch | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FunctionariesSwitch;
        } = await apiService.get(
            `/api/functionaries-switch/${idFunctionarySwitch}`
        );
        return data;
    } catch (error) {}
};

export const asyncDeleteFunctionariesSwitch = async (
    id: string
): Promise<void> => {
    try {
        await apiService.delete(`/api/functionaries-switch/${id}`);
    } catch (error) {
        console.error('Error al eliminar el funcionario:', error);
        throw error;
    }
};

export const asyncGetFunctionariesSwitchHistorical = async (
    idFunctionarySwitch: string
): Promise<FunctionariesSwitchHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: FunctionariesSwitchHistorical[];
        } = await apiService.get(
            `/api/functionaries-switch/${idFunctionarySwitch}/historical`
        );
        return data;
    } catch (error) {}
};

export const asyncGetFunctionaryByEmail = async (
    email: string
): Promise<
    | {
          area: any | null;
          functionary: {
              id: string;
              name: string;
              surname: string;
              email: string;
              extension?: string;
              position?: any | null;
          };
      }
    | undefined
> => {
    try {
        const { items: data }: any = await apiService.get(
            `/api/functionaries-switch/by-email`,
            { email }
        );
        return data;
    } catch (error) {}
};
